export interface VehicleEmission {
    id: number;
    name: string;
}

export const VEHICLE_EMISSIONS: VehicleEmission[] = [
    { id: 0, name: "Empty" },
    { id: 1, name: "Euro0" },
    { id: 2, name: "Euro1" },
    { id: 3, name: "Euro2" },
    { id: 4, name: "Euro3" },
    { id: 5, name: "Euro4" },
    { id: 6, name: "Euro5" },
    { id: 7, name: "Euro6" },
    { id: 8, name: "Euro6d" },
    { id: 9, name: "Euro6e" },
    { id: 10, name: "EEV" }
];